import React from 'react'

import {
    useHistory
} from 'react-router-dom'

import {
    NoMatchDiv,
    NoMatchComponentsDiv,
    NoMatchContentsDiv,
    QuickFillerTitleDiv,
    QuickFillerTitle,
    NoMatchTitleDiv,
    NoMatchPhraseDiv,
    NoMatchTitle,
    NoMatchPhrase
} from '../../Styles/Components/NoMatchDispStyles'

function NoMatchDisp(props){
    let history = useHistory()

    function mainPage(e){
        history.push('/')
    }
    return (
        <>
            <NoMatchDiv>
                <NoMatchComponentsDiv>
                    <NoMatchContentsDiv>
                        <QuickFillerTitleDiv>
                            <QuickFillerTitle onClick={mainPage}>QuickFiller</QuickFillerTitle>
                        </QuickFillerTitleDiv>
                        <NoMatchTitleDiv>
                            <NoMatchTitle>404 Page Not Found</NoMatchTitle>
                        </NoMatchTitleDiv>
                        <NoMatchPhraseDiv>
                            <NoMatchPhrase>The page you are looking for does not exist.</NoMatchPhrase>
                        </NoMatchPhraseDiv>
                    </NoMatchContentsDiv>
                </NoMatchComponentsDiv>
            </NoMatchDiv>
        </>
    )

}

export default NoMatchDisp;